<template>
  <div class="numberController">
    <div class="title">
      <img src="~@/assets/image/common/common_modification.png" alt="">
      <span class="text">选择人数</span>
      <!-- <span class="msg">每单上限{{  }}人</span> -->
      <ul class="numberControl">
        <li v-for="(item, index) in controllerNumber" :key="item.metaTicketInfo.productId">
          <div class="title">{{ item.metaTicketInfo.displayName }}</div>
          <div class="title">{{ item.metaTicketInfo.englishName }}</div>
          <div class="describe temporary" v-html="item.metaTicketInfo.summary"></div>
          <div class="ticketController">
            <span class="price">{{ item.salePrice }}元/张</span>
            <div class="controller">
              <div :class="{ 'disabled': item.count <= 0 }" @click="decrementNumber(item, index)">-</div>
              <input
                :value="item.count"
                oninput="value=value.replace(/[^\d]/g,'')"
                onafterpaste="value=value.replace(/[^\d]/g,'')"
                @blur="changeNumber($event, item, index)"
                @change="changeNumber($event, item, index)"
                type="number">
              <div :class="{ 'disabled': item.count >= item.maxCountPerOrder }" @click="incrementNumber(item, index)">+</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "numberController",
  props: {
    ticketInfoList: {
      type: Array,
    },
  },
  data(){
    return {
      controllerNumber: [],
    }
  },
  methods: {
    decrementNumber(item){
      if(item.count <= 0)return;
      -- item.count;
      this.changePeopleNumber();
    },
    changeNumber($event, item, index){
      const maxCountPerOrder = Number(item.maxCountPerOrder);
      let value = Math.floor($event.target.value);
      if(value < 0 || Number.isNaN(value))value = 0;
      if(value > maxCountPerOrder){
        this.$toast(`单票最大人数为${maxCountPerOrder}人`);
        value = maxCountPerOrder
      };
      item.count = null;
      this.$nextTick(() => {
        item.count = value;
      })
      this.changePeopleNumber();
      this.$forceUpdate();
    },
    incrementNumber(item, index){
      const maxCountPerOrder = Number(item.maxCountPerOrder);
      if(item.count >= maxCountPerOrder)return this.$toast(`单票最大人数为${maxCountPerOrder}人`);
      ++ item.count;
      this.changePeopleNumber();
    },
    changePeopleNumber(){
      this.$emit('changePeopleNumber', {
        controllerNumber: this.controllerNumber,
      })
    }
  },
  watch: {
    ticketInfoList:{
      handler(newValue){
        this.controllerNumber = newValue.map((item, i) => {
          const {
            ticketKindSn,
            maxCountPerOrder,
            salePrice,
            displayName,
            summary,
            } = item;
          const ticket = {
            // 唯一票的SN
            ticketKindSn,
            // 最大限制
            maxCountPerOrder,
            // 真实价格
            salePrice,
            // 票名
            displayName,
            // 概述
            summary,
            // 个数控制器
            count: 0,
            // 票详细
            metaTicketInfo: item,
          };
          return ticket;
        });
      },
      deep: true,
      immediate: true,
    }
  }
};
</script>

<style scoped lang='less'>
.numberController{
  background: #ffffff;
  padding: 0 .4rem .666667rem;
  border-radius: 0 0 0.16rem 0.16rem;
};
.title {
  line-height: 1;
  img{
    width: .533333rem;
    margin-right: .133333rem;
  }
  .text {
    font-weight: bold;
    color: #000000;
    font-size: 0.426667rem;
  }
  .msg {
    color: rgba(58, 62, 92, 0.7);
    font-size: 0.32rem;
    margin-left: 0.266667rem;
  }
}
.numberControl{
  & > li{
    background: #FFFFFF;
    box-shadow: 0 .053333rem .106667rem 0 rgba(0,0,0,0.05);
    border-radius: .213333rem;
    border: 1px solid rgba(151, 151, 151, 0.07);
    padding: .186667rem .226667rem .306667rem .28rem;
    margin-bottom: .4rem;
    &:last-child{
      margin-bottom: 0;
    }
    &:first-child{
      margin-top: .266667rem;
    };
    .title{
      font-size: .4rem;
      color: #333333;
      line-height: .56rem;
      font-weight: bold;
    }
    .describe{
      margin: .133333rem 0;
    }
    .ticketController{
      font-size: .4rem;
      font-weight: bold;
      color: #333333;
      line-height: .466667rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .price{
        font-size: .4rem;
        font-weight: bold;
        color: #333333;
        line-height: .466667rem;
      }
      .controller{
        display: flex;
        align-items: center;
        div{
          font-size: .6rem;
          color: #333333;
          line-height: .56rem;
          width: .826667rem;
          height: .826667rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        input{
          height: .826667rem;
          width: .826667rem;
          background: #F1F2F7;
          border-radius: .093333rem;
          text-align: center;
          font-size: .373333rem;
          color: #333333;
          line-height: .533333rem;
          margin: 0 .266667rem;
        }
        .disabled{
          color: #999999;
        }
      }
    }
  }
}
</style>
